import {CreateAccessor, GetDoc, GetDocs} from "mobx-graphlink";
import {EngineConfig} from "./engineConfigs/@EngineConfig";

export const GetEngineConfig = CreateAccessor((id: string): EngineConfig|n=>{
	return GetDoc({}, a=>a.engineConfigs.get(id));
});
export const GetEngineConfigs = CreateAccessor((userID?: string): EngineConfig[]=>{
	return GetDocs({
		params: {filter: {
			creator: userID && {equalTo: userID},
		}},
	}, a=>a.engineConfigs);
});

export const GetSelectedEngineConfigID = CreateAccessor({ctx: 1}, function() {
	return this.store.main.engine.config.selectedConfig;
});
export const GetSelectedEngineConfig = CreateAccessor(()=>{
	const selectedID = GetSelectedEngineConfigID();
	return GetEngineConfig(selectedID);
});